export enum ArticlePostStatus {
  AutoDraft = 1,
  Draft     = 2,
  Publish   = 3,
}